document.addEventListener("DOMContentLoaded", function() {
    let lastScrollPosition = 0;
    const header = document.getElementById("shopify-section-header");

    // Détecte si l’utilisateur est sur Chrome Mobile
    const isChromeMobile = /Chrome/.test(navigator.userAgent) && /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    // Applique la classe `fixed-header` pour Chrome Mobile uniquement
    if (isChromeMobile) {
        header.classList.add("fixed-header");
    }

    window.addEventListener("scroll", () => {
        const currentScrollPosition = window.pageYOffset;

        // Masque le menu en défilement vers le bas, montre en défilement vers le haut
        if (currentScrollPosition > lastScrollPosition) {
            header.classList.add("header-hidden");
        } else {
            header.classList.remove("header-hidden");
        }

        // Met à jour la dernière position de défilement
        lastScrollPosition = currentScrollPosition;
    });
});